import { Theme, Components } from '@mui/material/styles';

export const ToggleButtonOverrides: Components<Theme> = {
  MuiToggleButton: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({
        backgroundColor: '#FFFFFF',
        color: '#0F60FF',
        fontWeight: 300,
        border: 0,
        lineHeight: '100%',
        // transition: 'background-color, 220ms ease-in',
        transition: 'all, 250ms ease-in-out',

        '.MuiSvgIcon-root ': {
          transition: 'all 250ms ease-in-out',
          color: '#0F60FF',
        },

        '&:hover': {
          backgroundColor: '#ECF1FC',
        },

        '&.Mui-selected': {
          backgroundColor: '#1D2D66',
          color: '#FFFFFF',
          '.MuiSvgIcon-root ': {
            color: '#FFFFFF',
          },
          '&:hover': {
            backgroundColor: '#1D2D66B0',
          },
        },
      }),
      sizeMedium: {
        fontSize: 16,
        textTransform: 'uppercase',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 48,
        paddingRight: 48,
        ':has(.MuiSvgIcon-root)': {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
    },
  },
  MuiToggleButtonGroup: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({
        borderRadius: 50,
        boxShadow: '0px 16px 32px 0px #85879E80',
      }),
      firstButton: {
        borderTopLeftRadius: 50,
        borderBottomLeftRadius: 50,
      },
      lastButton: {
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
      },
    },
  },
};
